import { useEffect, useState } from 'react'

import { useMessages } from '@/modules/messages/hooks/useMessages'
import { DataTable } from '@/shared/components/data-table/DataTable'

import { marketingColumns } from '../../constants/marketingColumns'
import { useMarketing } from '../../hooks/useMarketing'

const PAGE_SIZE = 10

export function MarketingTable({ onEdit, onDelete, onMessage }) {
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const { marketing, meta, fetchMarketing, isLoading } = useMarketing()
  const { unreadCounts } = useMessages()

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim())
      setPage(1)
    }, 300)
    return () => clearTimeout(timer)
  }, [search])

  useEffect(() => {
    fetchMarketing({
      page,
      limit: PAGE_SIZE,
      ...(debouncedSearch ? { search: debouncedSearch } : {}),
    })
  }, [fetchMarketing, page, debouncedSearch])

  return (
    <DataTable
      columns={marketingColumns(
        onEdit,
        onDelete,
        onMessage,
        unreadCounts.bySender,
      )}
      data={marketing}
      loading={isLoading}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: 'Search by name, email or phone number...',
      }}
      filterSummary={`${marketing.length} of ${meta?.total ?? marketing.length}`}
      pagination={{
        page,
        pageSize: PAGE_SIZE,
        total: meta?.total ?? marketing.length,
        onPageChange: setPage,
      }}
    />
  )
}
